import { useCallback, useEffect, useState } from "react";
import { useDebounce } from "../../../hooks/usedebounce";
import { Rule } from "../../../models/rule";
import { RuleService } from "../../../services/rule-services";

export type RulesState = {
  loading: boolean;
  rules: Rule[];
  query: string;
  debouncedQuery: string;
  page: number;
  pageSize: number;
  total: number;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  updatePaging: (page: number, pageSize: number) => void;
};

export default function useRules() {
  const [loading, setLoading] = useState<boolean>(true);
  const [rules, setRules] = useState<Rule[]>([]);
  const [query, setQuery] = useState<string>("");
  const [pageSize, setPageSize] = useState<number>(15);
  const [page, setPage] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const debouncedQuery = useDebounce(query, 800);

  const getRules = useCallback(
    async (page: number, pageSize: number) => {
      if (debouncedQuery) {
        setLoading(true);
      }
      try {
        const newRulesPaged = await RuleService.getRulesPaged(
          page,
          pageSize,
          debouncedQuery
        );
        setPage(newRulesPaged.page);
        setPageSize(newRulesPaged.pageSize);
        setTotal(newRulesPaged.total);
        setRules(newRulesPaged.rules);
      } catch (e) {
        //TODO: error display
        alert(e);
      } finally {
        setLoading(false);
      }
    },
    [debouncedQuery]
  );

  const updatePaging = (newPage: number, newPageSize: number) => {
    setPage(newPage);
    setPageSize(newPageSize);
    getRules(newPage, newPageSize);
  };

  useEffect(() => {
    setPage(0); // query changed go back to page 1
    getRules(0, pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuery]);

  return {
    loading,
    rules,
    query,
    debouncedQuery,
    page,
    pageSize,
    total,
    setQuery,
    updatePaging,
  };
}
